// Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 LLC. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

import { FunctionComponent, PropsWithChildren, ReactElement } from "react";
import { Footer } from "../components/Footer";
import { Outlet } from "react-router-dom";
import Header from "../components/header/Header";
import { NavBar } from "../components/SideNavBar";
import './../styles/BaseLayout.css'
import { IdleDetectionHandler } from "../components/IdleDetectionHandler";

interface BaseLayoutPropsInterface {
}

export const BaseLayout: FunctionComponent<PropsWithChildren<BaseLayoutPropsInterface>> = (
): ReactElement => {

    return (
        <div className="wrapper">
            <IdleDetectionHandler />
            <div className="header top-nav-bar">
                <Header />
            </div>
            <div className="nav">
                <NavBar />
            </div>
            <div className="cont">
                <Outlet />
            </div>
            <div className="footer">
                <Footer />
            </div>
        </div>
    )
}
